module.exports = __webpack_public_path__ + "static/media/pov_whole_GreatStellatedDodecahedron.8a2eee9c.png";